import { render } from "./Modal2.vue?vue&type=template&id=574eccf4&scoped=true"
import script from "./Modal2.vue?vue&type=script&lang=js"
export * from "./Modal2.vue?vue&type=script&lang=js"

import "./Modal2.vue?vue&type=style&index=0&id=574eccf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574eccf4"]])

export default __exports__